import { Cell, Grid } from 'baseui/layout-grid'
import { FormControl } from 'baseui/form-control'
import { ModalHeader, ModalBody, ModalButton, Modal, ROLE } from 'baseui/modal'
import { Textarea } from 'baseui/textarea'
import useAbandonContract from './useAbandonContract'
import { Button, KIND, SIZE } from 'baseui/button'
import IconCarbonTrashCan from '@/shared/icons/IconCarbonTrashCan'

const AbandonContract = () => {
  const {
    t,
    css,
    reason,
    error,
    isLoading,
    sendReason,
    setReason,
    isOpen,
    setIsOpen,
    canShowAbandonButton,
    isAlreadyRetracted,
  } = useAbandonContract()

  if (!canShowAbandonButton || isAlreadyRetracted) {
    return null
  }

  return (
    <>
      <Button
        kind={KIND.secondary}
        size={SIZE.compact}
        onClick={() => setIsOpen(true)}
        startEnhancer={() => <IconCarbonTrashCan size={24} />}
      >
        {t('subscriptionTable:abandon')}
      </Button>
      <Modal onClose={() => setIsOpen(false)} isOpen={isOpen} animate autoFocus size={SIZE.full} role={ROLE.dialog}>
        <ModalHeader>{t('subscriptionTable:abandon_subscription')}</ModalHeader>
        <ModalBody>
          <Grid>
            <Cell span={12}>
              <FormControl label={t('subscriptionTable:abandon_why')} error={error}>
                <Textarea
                  value={reason}
                  onChange={e => setReason(e.target.value)}
                  size={SIZE.mini}
                  placeholder={t('subscriptionTable:write_comment')}
                  clearable
                />
              </FormControl>
              <FormControl>
                <ModalButton
                  className={css({ width: '100%' })}
                  isLoading={isLoading}
                  disabled={reason?.trim().length < 10}
                  onClick={sendReason}
                  size={SIZE.mini}
                >
                  {t('subscriptionTable:abandon')}
                </ModalButton>
              </FormControl>
            </Cell>
          </Grid>
        </ModalBody>
      </Modal>
    </>
  )
}

export default AbandonContract
